import axios from 'axios';
import getVariableType from './getVariableType';

function request(options) {
  return new Promise((resolve, reject) => {
    const requestSettings = {
      url: options.url,
      method: options.method || 'get',
      headers: {
        ...options.headers,
      },
      data: options.data,
      params: options.params,
    };
    if (options.debugRequest) {
      console.log(requestSettings);
    }
    axios(requestSettings)
      .then((response) => {
        const { headers } = response;
        if (headers['content-type'].includes('application/json')) {
          resolve(response.data);
          return;
        }
        resolve(response);
      })
      .catch((error) => {
        const responseData = error.response.data;
        const errorData = extractErrorData(responseData);
        errorData._response = error.response;
        console.error(errorData);
        // reject(errorData);
        resolve(errorData);
        return;
      });
  });
}

function extractErrorData(responseData) {
  const variableType = getVariableType(responseData);
  const errorData = variableType === 'string' ? {
    code: 'unknown',
    message: responseData,
  } : responseData;
  return errorData;
}

async function post(url, data, options) {
  return request({
    url,
    method: 'post',
    data,
    ...options,
  });
}

export default {
  post,

  request,
};
